/* codex_homepage_noop_v1: disabled on homepage for iPhone stability; original runs elsewhere. asset=assets/halo-toolcart.js */
if (!(location.pathname === '/' || location.pathname === '' || /^\/[a-z]{2}(?:-[A-Z]{2})?\/?$/.test(location.pathname))) {
class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.currentTarget.dataset.popup;
        const popup = id ? document.getElementById(id) : null;
        const previewCart = document.querySelector('.previewCart');
        if (!popup || !previewCart) return;
        popup.classList.add('show');
        previewCart.classList.add('active-tool');
      })
    })
  }
}

if (!customElements.get('cart-item-tool')) customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button')?.addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');
    })
  }
}

if (!customElements.get('cart-cancel-popup')) customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]')?.addEventListener('click', (event) => {
      const textArea = this.querySelector('.text-area');
      if (!textArea) return;
      this.val = textArea.value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');
    })
  }
}

if (!customElements.get('cart-note')) customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    const discountInput = this.querySelector('input[name="discount"]');
    if (discountInput && localStorage.getItem('storedDiscount')){
      discountInput.value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]')?.addEventListener('click', (event) => {
      if (!discountInput) return;
      this.val = discountInput.value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');
    })
  }
}

if (!customElements.get('coupon-code')) customElements.define('coupon-code', CouponCode);
}
